"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Container = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var container_style_1 = require("./container-style");
var container_type_1 = require("./container-type");
function Container(props) {
    var _a = props.type, type = _a === void 0 ? container_type_1.ContainerType.STATIC_MARGIN : _a, _b = props.width, width = _b === void 0 ? 'unset' : _b, children = props.children;
    return ((0, jsx_runtime_1.jsx)(container_style_1.StyledContainer, { type: type, width: width, children: children }));
}
exports.Container = Container;
